<template>
  <span>{{ output }}</span>
</template>

<script setup>
import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(advancedFormat)
dayjs.extend(relativeTime)

/**
 * @typedef {Object} DateCellParams
 * @param {String} value
 * @param {String} [formatter]
 */
const props = defineProps({
  /** @type {DateCellParams} */
  params: {
    type: Object,
    required: true
  }
})

const output = (() => {
  if (!props.params.value) {
    return ''
  }

  if (props.params.formatter && props.params.formatter === 'fromNow') {
    return dayjs(props.params.value).fromNow()
  } else {
    return dayjs(props.params.value).format(props.params.formatter || 'MMM Do, YYYY [at] h:mmA')
  }
})()
</script>
